<br>
<div *ngIf="!display && username" class="col-md-4 col-sm-6 ms-3" style="min-width: 300px;">
  <mat-expansion-panel [expanded]=true class="accordionmargin">
    <mat-expansion-panel-header [expandedHeight]="'48px'">
      <mat-panel-title>
        Ändra lösenord för {{username}}
      </mat-panel-title>
      
    </mat-expansion-panel-header>
    <div class="col-md-5">
      <img src="../../../../assets/oddfellow_logga.PNG" />

    </div>

    <br>
    <div class="row">

      <div class="col-md-6">
        <form [formGroup]="passwordform" style="margin-left:5px;margin-right:5px;">

          <div class="form-group col-md-12 col-sm-12" style="min-width: 250px;">
            <label for="password">
              Välj nytt lösenord <i class="fa fa-eye" (mouseover)="pwshow=!pwshow"
              (mouseout)="pwshow=!pwshow"></i>
            </label>

            <input [type]="pwshow ? 'text' : 'password'" class="form-control form-control-sm" id="password" formControlName="password" required>

          </div>


          <div class="form-group col-md-12 col-sm-12" style="min-width: 250px;">
            <label for="passwordConfirmation">
              Konfirmera lösenord <i class="fa fa-eye" (mouseover)="confirmpwshow=!confirmpwshow"
              (mouseout)="confirmpwshow=!confirmpwshow"></i>
            </label>
            <input [type]="confirmpwshow ? 'text' : 'password'" class="form-control form-control-sm" id="passwordConfirmation" formControlName="passwordConfirmation"
              required>
          </div>
          <br>
          <div class="col-md-8 col-sm-10">
            <button class="btn border" style="width: 210px;" (click)="changePassword()" [disabled]="!passwordform.valid">Verkställ</button>
          </div>
        </form>
      </div>

    </div>
    <hr />
    <div style="background-color:rgb(245, 253, 245);border-radius:5px;padding:10px;border:1px solid #F0F0F0;">
      <b>Regler för lösenord</b>
      <p>- Minst 8 tecken</p>
      <p>- Minst 4 unika tecken</p>
      <p>- Minst en siffra</p>
      <p>- Både stora och små bokstäver</p>
      <p>- Minst ett specialtecken (!&#64;$?_-)</p>
    </div>
  </mat-expansion-panel>
</div>

<div class="ms-3">  
  <app-reset-password-dialog *ngIf="display" [errorlist]="errorlist" type="{{type}}" (doCancel)="cancel()" (doContinue)="continue()"></app-reset-password-dialog>
</div>

